import { useNavigate } from 'react-router-dom';
import { detailing2 } from '../../imports';
import './About.css';

const About = () => {
    const navigate = useNavigate();
    return (
        <div className="about-container">
            <div className='about-overlay'></div>
            <div className="about-header-container">
                <p className='about-pre-header'>Become a Member</p>
                <h1 className='about-header'>Keep it clean and organized</h1>
                <p className='about-description'>We are a team of professionals who allow you to keep your car in pristine condition, offering top-notch detailing services.</p>
                <button className='about-button' onClick={() => navigate('/memberships')}>View Memberships</button>
            </div>
            <div className="about-image-container">
                <img src={detailing2} alt="car detailing" />
            </div>
        </div>
    )
}

export default About;